import { TenDashboardResultsMain } from './components/TenDashboardResultsMain';

const TenDashboardResults = TenDashboardResultsMain;

export { TenDashboardResults };